import { firebaseClient, getToken } from "../firebaseClient";
import * as Sentry from "@sentry/nextjs";


// const baseUrl = "http://127.0.0.1:5001/ez4cast/us-central1";
const baseUrl = "https://us-central1-ez4cast.cloudfunctions.net";


export const getPosts = async (userId, profileId, session) => {
  try {
    const token = await getToken(session, "mentions-getPosts");
    const response = await fetch(`${baseUrl}/linkedinSocialListening-getMentionsPosts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        tokenUserId: session?.user.uid || "",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        userId,
        profileId,
        isInfluentLeader: true,
      }),
    });
    if (!response.ok) {
      throw new Error("Error getting posts");
    }
    const data = await response.json();
    if (!data.posts || data.success === 0) {
      throw new Error("Error getting posts");
    }
    const sortedPosts = data.posts.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    return sortedPosts;
  } catch (error) {
    console.error("Error getting posts:", error);
    Sentry.captureException(error);
    return null;
  }
}

export const fetchMentionsForProfile = async (userId, profile, session) => {
  const token = await getToken(session, "mentions-fetchMentionsForProfile");
  const response = await fetch(`${baseUrl}/linkedinSocialListening-fetchMentionsForProfile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      tokenUserId: session?.user.uid || "",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      profile,
      isInfluentLeader: true,
    }),
  });
  if (!response.ok) {
    throw new Error("Error fetching posts");
  }
  const data = await response.json();
  if (data.success === 0) {
    throw new Error("Error fetching posts");
  }
  return data.success;
}

export const removeProfilePosts = async (userId, profileId, session) => {
  const token = await getToken(session, "mentions-removeProfilePosts");
  const response = await fetch(`${baseUrl}/linkedinSocialListening-initiateRemoveProfileMentions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      tokenUserId: session?.user.uid || "",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      profileId,
      isInfluentLeader: true,
    }),
  });
  if (!response.ok) {
    throw new Error("Error removing profile");
  }
  const data = await response.json();
  if (data.success === 0) {
    throw new Error("Error removing profile");
  }
  return data.success;
}